import React from "react"
import { useAdertisementData } from "./utils"

export const LeaderboardContent = ({
  ressort,
  adbutler_page_id,
  adbutler_place,
  tags,
  topic,
}) => {
  // Client-side Runtime Data Fetching
  const adbutlerIds = {
    baumagazin: 606970,
    galabau: 606972,
    umweltbau: 606980,
  }

  const state = useAdertisementData({
    adbutler_page_id,
    place: adbutler_place,
    set_id: adbutlerIds[ressort],
    tags,
    ressort,
    topic,
  })

  return (
    <React.Fragment>
      {state.body || state.imageURL ? (
        <div className="mx-1-mobile">
          <div
            data-nosnippet
            className="ad-wrapper my-6 mx-auto"
            style={{ minHeight: 100 }}
          >
            {state.body ? (
              <div
                className="html-leaderboard-content"
                dangerouslySetInnerHTML={{ __html: state.body }}
              ></div>
            ) : state.imageURL ? (
              <a
                href={state.redirectURL}
                target={state.link_target}
                rel="noopener noreferrer"
                title={`Anzeige`}
              >
                <img
                  src={state.imageURL}
                  alt={`Anzeige`}
                  title={`Anzeige`}
                  width={state.imageWidth || "auto"}
                  height={state.imageHeight || "auto"}
                />
              </a>
            ) : null}
            <div className="ad-disclaimer">Anzeige</div>
          </div>
          {!!state?.tracking_pixel ? (
            <img
              alt=""
              src={state?.tracking_pixel}
              border="0"
              width="1"
              height="1"
            />
          ) : null}
        </div>
      ) : null}
    </React.Fragment>
  )
}
